import {
    NAME_PRODUCTS,
    NAME_TASKS,
    NAME_BRAND_ASSETS,
    NAME_CONTENT_AGREEMENT,
    NAME_COMPENSATION,
    NAME_PERSONAL_INFO,
} from '../../../../constants/activation-brief-steps';

const orderedStepKeys = [
    'has_module_tasks_and_content_tracking',
    'has_module_products',
    'has_module_conversion_tracking',
    'has_module_payments',
    'has_module_additional_info',
    'has_module_assets',
    'has_module_content_agreement',
];

const moduleStepMap = {
    [NAME_TASKS]:             'has_module_tasks_and_content_tracking',
    [NAME_PRODUCTS]:          'has_module_products',
    [NAME_COMPENSATION]:      'has_module_payments',
    [NAME_PERSONAL_INFO]:     'has_module_additional_info',
    [NAME_BRAND_ASSETS]:      'has_module_assets',
    [NAME_CONTENT_AGREEMENT]: 'has_module_content_agreement',
};

export default {
    methods: {
      getMockStepState(module, brief) {
            const activeSteps = orderedStepKeys.filter((step) => {
                return brief[step] === true;
            });

            const currentStepIndex = activeSteps.findIndex((step) => step === moduleStepMap[module]);

            return {
                meta: {
                    stepNumber: currentStepIndex + 1,
                    totalSteps: activeSteps.length,
                },
            };

      },
    },
};
